/**
 * Organization context utilities for localStorage management
 */

const ORG_STORAGE_KEY = "mimber-organization-selected-id"

/**
 * Get the currently selected organization ID from localStorage
 * @returns The organization UUID or null if none selected
 */
export const getSelectedOrganizationId = (): string | null => {
  return localStorage.getItem(ORG_STORAGE_KEY)
}

/**
 * Set the selected organization ID in localStorage
 * @param uuid The organization UUID to store
 */
export const setSelectedOrganizationId = (uuid: string): void => {
  localStorage.setItem(ORG_STORAGE_KEY, uuid)
}

/**
 * Clear the selected organization ID from localStorage
 */
export const clearSelectedOrganizationId = (): void => {
  localStorage.removeItem(ORG_STORAGE_KEY)
}
